module.exports = __webpack_public_path__ + "img/date.f7fca0e2.svg";